// Helpers for the Wingman PWA: service worker registration + Web Push.
import axios from 'axios';
import { devError } from '../utils/logger';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const VAPID_PUBLIC_KEY = process.env.REACT_APP_VAPID_PUBLIC_KEY;

export const isWingmanSupported = () =>
  typeof window !== 'undefined' &&
  'serviceWorker' in navigator &&
  'PushManager' in window &&
  'Notification' in window;

export const registerWingmanServiceWorker = async () => {
  if (!('serviceWorker' in navigator)) return null;
  try {
    return await navigator.serviceWorker.register('/wingman-sw.js', { scope: '/wingman' });
  } catch (e) {
    devError('wingman SW register failed', e);
    return null;
  }
};

const urlBase64ToUint8Array = (base64) => {
  const padding = '='.repeat((4 - (base64.length % 4)) % 4);
  const b64 = (base64 + padding).replace(/-/g, '+').replace(/_/g, '/');
  const raw = window.atob(b64);
  return Uint8Array.from([...raw].map((c) => c.charCodeAt(0)));
};

const arrayBufferToBase64 = (buf) => {
  const bytes = new Uint8Array(buf);
  let binary = '';
  for (let i = 0; i < bytes.byteLength; i++) binary += String.fromCharCode(bytes[i]);
  return window.btoa(binary);
};

export const enableWingmanPush = async () => {
  if (!isWingmanSupported()) return { ok: false, reason: 'unsupported' };
  if (!VAPID_PUBLIC_KEY) return { ok: false, reason: 'no_vapid_key' };

  const permission = await Notification.requestPermission();
  if (permission !== 'granted') return { ok: false, reason: 'permission_denied' };

  const reg = await registerWingmanServiceWorker();
  if (!reg) return { ok: false, reason: 'sw_failed' };

  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    sub = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(VAPID_PUBLIC_KEY),
    });
  }

  const json = sub.toJSON();
  const p256dh = json.keys?.p256dh || arrayBufferToBase64(sub.getKey('p256dh'));
  const auth = json.keys?.auth || arrayBufferToBase64(sub.getKey('auth'));

  await axios.post(`${API}/wingman/push/subscribe`, {
    endpoint: sub.endpoint,
    p256dh,
    auth,
    user_agent: navigator.userAgent,
  });
  return { ok: true };
};

export const sendTestPush = async () => {
  const { data } = await axios.post(`${API}/wingman/push/test`);
  return data;
};
